import { render, staticRenderFns } from "./MapColorizers.vue?vue&type=template&id=0da00fce&"
import script from "./MapColorizers.vue?vue&type=script&lang=js&"
export * from "./MapColorizers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports